import React from "react";
import { Popconfirm } from "antd";
import { useFormContext } from "react-hook-form";
import { BookOpen } from "react-feather";
import PropTypes from "prop-types";
import { IoPencil } from "react-icons/io5";
import { hasPermission } from "core/Operations/checkPermission";

const EditController = ({ isDisabled, id, editHandler, permissions }) => {
  const { watch, setValue, getValues } = useFormContext();

  const hasEditPermission = hasPermission(
    permissions,
    "Time & Attendance",
    "Time Tracking",
    "haveEdit",
  );
  const wtEditHandler = (id) => {
    const attendance = watch("attendance");
    const index = attendance.findIndex((a) => a.id === id);
    if (id !== -1) {
      setValue(`attendance[${id}].isApproved`, false);
      setValue(`attendance[${id}].isReviewed`, false);
    } else {
      console.warn(`No attendance entry found for id: ${id}`);
    }
  };

  return (
    <Popconfirm
      title="Edit the row?"
      description="Really want to edit this date?"
      icon={<BookOpen className="me-2" />}
      onConfirm={() => editHandler(id)}
      onCancel={() => console.log("Cancel")}
      okText="Yes"
      cancelText="No"
    >
      <button
        type="button"
        className="btn btn-secondary btn-sm"
        disabled={
          getValues(`attendance[${id}]?.isApproved`) === true &&
          hasEditPermission === true
            ? false
            : isDisabled
        }
      >
        <IoPencil />
      </button>
    </Popconfirm>
  );
};

EditController.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  editHandler: PropTypes.func.isRequired,
  permissions: PropTypes.array.isRequired,
};

export default React.memo(EditController);
